import React from 'react';
import { usePageTracking } from '@/hooks/usePageTracking';

export const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};
